var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNumberIcon7(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 70.781,
    height: 89.135,
    viewBox: "0 0 70.781 89.135",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Path_32395",
    x: 0,
    y: 0,
    width: 70.781,
    height: 89.135,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 0, 0)",
    filter: "url(#Path_32395)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32395-2",
    "data-name": "Path 32395",
    d: "M15.36-53.181H-18.03q-6.222,0-6.222-5.5a12.415,12.415,0,0,1,.467-3.266A7.714,7.714,0,0,1-22.7-64.484H21.167q7.362,0,7.362,6.118a15.991,15.991,0,0,1-.57,3.889,30.67,30.67,0,0,1-1.607,4.614L1.361,6.651H-11.186Z",
    transform: "translate(33.25 70.48)",
    fill: "#fcbf49"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNumberIcon7);
export default __webpack_public_path__ + "static/media/number-icon7.708f600dd14325eb909e68b88b8cac22.svg";
export { ForwardRef as ReactComponent };